import { Box, Typography } from '@mui/material';

const YEAR = new Date().getFullYear();

export const SiteFooter = (): JSX.Element => {
  return (
    <Box
      component='footer'
      className='site-footer'
      sx={{ flexShrink: 0, py: 2.5, px: 2, backgroundColor: '#ffffff', borderTop: '1px solid', borderColor: 'grey.200' }}
    >
      <Typography
        className='site-footer__text'
        sx={{ textAlign: 'center', fontSize: 11, color: 'text.secondary' }}
      >
        {YEAR} Gerson Lehrman Group Inc. All rights reserved. GLG and the GLG logo are trademarks of Gerson Lehrman
        Group, Inc.
      </Typography>
    </Box>
  );
};
